import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GasTravel } from '../models/gas-travel';
import { Observable } from 'rxjs';
import { PayService } from '../models/pay-service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http:HttpClient) { }

  gasReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/base/gas', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  gasReportAll(date1:Date, date2:Date) : Promise<GasTravel[]> {
    return this.http.get<GasTravel[]>('/api/reports/base/gas/all', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  travelsReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/travels', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  maintenanceReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/base/maintenance', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  kmReport(date1:Date, date2:Date, closed:boolean) : Promise<any> {
    return this.http.get<any>('/api/reports/base/km', {params: {date1: date1.toString(), date2: date2.toString(), closed: closed + ""}})
      .toPromise();
  }

  proecoReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/base/proeco', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  extraExpenseReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/base/extra-expenses', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  paysheetReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/base/paysheet', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  travelPaysheetReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/base/travel/paysheet', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  totalExpensesReport(date1:Date, date2:Date, type:string) : Promise<any> {
    return this.http.get<any>('/api/reports/total/expenses', {params: {date1: date1.toString(), date2: date2.toString(), type}})
    .toPromise();
  }
  
  getPendingGasReport() : Promise<GasTravel[]> {
    return this.http.get<GasTravel[]>('/api/reports/base/gas/sap').toPromise();
  }

  binnacleReport(date1:Date, date2:Date) : Promise<any> {
    return this.http.get<any>('/api/reports/binnacle', {params: {date1: date1.toString(), date2: date2.toString()}})
      .toPromise();
  }

  getPayServiceReport(date1:Date, date2:Date):Observable<PayService[]>{
		let params = new HttpParams()
		    .append("date1", date1.toISOString().toString().substr(0, 10))
			.append("date2", date2.toISOString().toString().substr(0, 10));
		return this.http.get<PayService[]>('/api/reports/pay-services',{params});
	}

  cuadre(mes:number) : Promise<any> {
    return this.http.get<any>('/api/reports/cuadrarMes', {params: {mes: mes.toString()}})
      .toPromise();
  }
  
  repDiferencias(mes:number,type:string) : Promise<any> {
    return this.http.get<any>('/api/reports/repDiferencias', {params: {mes: mes.toString(),type}})
      .toPromise();
  }


}
